export default __webpack_public_path__ + "static/media/jasmine.4cc3c622.svg";